export default __webpack_public_path__ + "fonts/OpenSans-Italic-webfont.ttf";